import './Footer.scss';

const Footer = ({carrinho}) => {
    return (
        <div className={`footer`}>
            <div className='text'>
                Este site não é uma plataforma de compra!
            </div>
        </div>
    )
}

export default Footer;